import React from 'react';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';

import s from './SimpleContentWrapper.scss';

export interface Props {
  children: React.ReactNode;
}

const SimpleContentWrapper: React.FC<Props> = ({ children }) => {
  return (
    <ThemeOverride theme={ThemeOptions.DARK}>
      <div className={s['root']}>{children}</div>
    </ThemeOverride>
  );
};

SimpleContentWrapper.displayName = 'SimpleContentWrapper';

export default SimpleContentWrapper;
